import React, { Fragment } from "react";
import { HashLink as Link } from "react-router-hash-link";
import PropTypes from "prop-types";
import "./styles.css";

const OpcionesServiciosComponent = (props) => {
  return (
    <Fragment>
      <div className="servicio-contenedor-nav" align="center">
        <div id="content-servicios">
          <div>
            <Link to={"#" + props.cambiar.idAncla}>
              <img
                id={props.cambiar.idAncla + "-" + props.cambiar.id}
                src={props.cambiar.icono}
                alt=""
              />
            </Link>
          </div>
        </div>
        <div className="servicio-contenedor-nombre">
          <small>
            <b> {props.cambiar.nombre} </b>
          </small>
        </div>
      </div>
    </Fragment>
  );
};

OpcionesServiciosComponent.propTypes = {
  cambiar: PropTypes.object,
  evento: PropTypes.func,
};

export default OpcionesServiciosComponent;
